import { Extension, type Editor } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

const key = new PluginKey<number | null>('imageUploadPlaceholder')

/** Где сейчас грузится картинка; позиция едет вместе с текстом, пока автор печатает. */
export const uploadPlaceholderPos = (editor: Editor): number | null =>
  key.getState(editor.state) ?? null

export const setUploadPlaceholder = (editor: Editor, pos: number | null): void => {
  editor.view.dispatch(editor.state.tr.setMeta(key, pos))
}

/** Держит на месте будущей картинки `host`: прогресс в него рисует `NotionEditor`. */
export const UploadPlaceholder = (host: HTMLElement) =>
  Extension.create({
    name: 'imageUploadPlaceholder',
    addProseMirrorPlugins: () => [
      new Plugin<number | null>({
        key,
        state: {
          init: () => null,
          apply: (tr, pos) => {
            const next = tr.getMeta(key) as number | null | undefined
            if (next !== undefined) {
              return next === null ? null : Math.min(next, tr.doc.content.size)
            }
            return pos === null ? null : tr.mapping.map(pos)
          },
        },
        props: {
          decorations: (state) => {
            const pos = key.getState(state) ?? null
            return pos === null
              ? null
              : DecorationSet.create(state.doc, [
                  Decoration.widget(pos, () => host, { key: 'image-upload', side: -1 }),
                ])
          },
        },
      }),
    ],
  })
